const Minus = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 12.6H5V11.4H19V12.6Z"
        fill="black"
        style={{ fill: "var(--svg-color" }}
      />
    </svg>
  );
};

export default Minus;
